import "./style.css";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import * as React from "react";
import { MenuEllipseProps, OptionMenuProps } from "./MenuEllipseProps";
import { GenericType } from "../DataTable/DataTableProps";

const MenuEllipse = <T extends GenericType>({
  listeOptions,
  data,
}: MenuEllipseProps<T>) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const ITEM_HEIGHT = 48;
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const style = {
    "font-weight": "bold",
    "font-size": "16px",
    margin: "7px",
    color: "#1479CC",
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "auto",
          },
        }}
      >
        {listeOptions.map((option: OptionMenuProps<T>) => (
          <MenuItem
            key={option.key}
            selected={option.selected}
            onClick={(e) => {
              if (option.onClick) {
                option.onClick(e, data);
              }
              handleClose();
            }}
            style={style}
          >
            {option.key}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MenuEllipse;
